import React, {Component} from 'react';
import PropTypes from 'prop-types';


import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Info';
import { ListItemButton } from '@mui/material';

const s:any = {
  active: {
    color: 'primary.main',
    fontWeight: 'typography.fontWeightMedium',
  },
  nested: {
    paddingLeft: 1,
  },
  itemicon: {
    minWidth: 24,
    mr: 1,
  }
};

class DynamicMenuChild extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  
  componentDidMount() {
    // So we only run this logic once.
    if (!this.props.openImmediately) {
      return;
    }

    // Center the selected item in the list container.
    const activeElement = document.querySelector(`.${this.props.classes.active}`);
    if (activeElement && activeElement.scrollIntoView) {
      activeElement.scrollIntoView({});
    }
  }

  render() {
    const {
      children,
      classes,
      index,
      action,
      onClick,
      openImmediately,
      title,
      ...other
    } = this.props;
    
    const {activeid} = this.props;
    const active = (index === activeid);

    return (
      <ListItem onClick={onClick(null,action,index)} {...other} sx={{...s.nested}}> 
        <ListItemButton selected={active}
  sx={{
    borderRadius: "8px",
    mx: 1,
    "&.Mui-selected": {
      backgroundColor: "rgba(255,255,255,0.12)",
    },
  }}>
          <ListItemIcon sx={{...s.itemicon}}>
            <MenuIcon />
          </ListItemIcon>
          <ListItemText primary={title} />
        </ListItemButton>
      </ListItem>
    );
    
  }
}

DynamicMenuChild.propTypes = {
  //classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  openImmediately: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

DynamicMenuChild.defaultProps = {
  openImmediately: false,
};

export default DynamicMenuChild;
